import React from 'react';
import { Feature } from '@tencent/workbench';
import BaseDrawerEffectFeature from '@framework/workbench/common/feature/base-drawer-effect-feature';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import { FormItemName, INPUT_PROPS_CALLBACK_KEY } from '@framework/workbench/drawer/constants';
import i18n from '@i18next/i18n';
import PresetPanel from '../../../components/preset-panel';
import RecolorPresetMenu from '@src/framework/frame-pc/components/palette-panel/recolor-preset-menu';
import { IPictureModel } from '@src/slide/domain/ui-model/element-modeles/Interface/picture-model.interface';
import { DEFAULT_IMAGE_COLOR } from '@src/slide/domain/ui-model/element-modeles/property/image-operation/constant/props-value';
import { handleInputBlurInitAndReset } from '@src/slide/application/service/drawer-input-manager/drawer-handler';
import { NumberInputFrom } from '@tencent/wb-ext-form';
import { RecolorCache } from '@src/framework/frame-pc/components/palette-panel/recolor-preset-menu/recolor-cache';
import LabelBtn from '@framework/workbench/drawer/components/label-btn';

@Feature()
export class PictureColorFeature extends BaseDrawerEffectFeature {
    public pictureColorProps = { ...DEFAULT_IMAGE_COLOR };
    public get pictureColorInfo() {
        const pictureColor = this.getPropertyMenu()?.values?.[ActionType.PICTURE_COLOR];
        return pictureColor ? pictureColor : DEFAULT_IMAGE_COLOR;
    }
    public get saturate() {
        return this.pictureColorProps?.saturate;
    }
    public get colorTemperature() {
        return this.pictureColorProps?.colorTemperature;
    }

    public constructor() {
        super();
        this.addInitPropsCallback(INPUT_PROPS_CALLBACK_KEY.PICTURE_COLOR);
    }

    public initPropsCallback = () => {
        this.pictureColorProps = { ...this.pictureColorInfo };
    };

    public renderReset() {
        return <LabelBtn text={i18n.t('重置')} onClick={() => this.resetClick()} disabled={this.isGifOrSvg()}/>;
    }

    public renderReColor() {
        const model = this.getSelectModel() as  IPictureModel;
        return  (<PresetPanel isMultiDifferent={true}>
            <RecolorPresetMenu
                model={model}
                onRecolorStyleClick={
                    (value) => {
                        const props = {
                            value,
                            onlyChangeUI: false,
                        };
                        this.updatePictureColorProps(props, false);
                    }
                }/>
        </PresetPanel>);
    }

    public clearRecolorCache() {
        RecolorCache.getInstance().clearCache();
    }

    @handleInputBlurInitAndReset(INPUT_PROPS_CALLBACK_KEY.PICTURE_COLOR)
    public handlePictureColorChange(value: number, type: string, from?: NumberInputFrom, dragEnd?: boolean) {
        const onlyChangeUI = this.isInputOnlyChangeUIWithDrag(dragEnd);
        this.updatePictureColorProps({ value: { [type]: value }, onlyChangeUI, from });
        this.tdwDrawerReportNumberInput(type, { ver6: value }, from, onlyChangeUI);
    }

    private updatePictureColorProps = (props, needClearRecolorCache = true) => {
        const { value, onlyChangeUI, onPreview, reportInfo, from } = props;
        if (needClearRecolorCache) {
            this.clearRecolorCache();
        }
        this.pictureColorProps = { ...this.pictureColorInfo, ...value };
        this.updateProps(ActionType.PICTURE_COLOR, value, onlyChangeUI, onPreview, reportInfo);
    };

    private resetClick = (): void => {
        const resetValue: any = {
            ...DEFAULT_IMAGE_COLOR,
            grayscl: null,
            duotone: null,
            biLevel: null,
            luminance: null,
        };
        this.updatePictureColorProps({
            value: resetValue,
            onlyChangeUI: false,
            onPreview: false,
            reportInfo: { reportId: FormItemName.PICTURE_COLOR_RESET },
        });
    };
}
